class FuncionesVarias {
  variabelDatosSuscriptor = "suscrip_info"
  formatoMoneda(numero) {
    return "$ " + numero;
  }

  guardaDatosSuscriptor(data) {
    //Las tarifas deberán venir desde la base de datos
    data.configuracion.tarifasDistancias = [
      { maximaDistancia: 900, tarifa: 0 },
      { maximaDistancia: 2000, tarifa: 30 },
      { maximaDistancia: 4000, tarifa: 50 },
      { maximaDistancia: 5000, tarifa: 60 }
    ];
    sessionStorage.setItem(this.variabelDatosSuscriptor, JSON.stringify(data));
  }

  leerDatosSuscriptor() {
    var json = sessionStorage.getItem(this.variabelDatosSuscriptor);
    return JSON.parse(json);
  }

  leerSuscriptor()
  {
    return this.leerDatosSuscriptor().suscriptor;
  }

  leerConfiguracionSuscriptor() {
    var suscriptor = this.leerDatosSuscriptor();
    return suscriptor.configuracion;
  }

  calcularDistanciaANegocio(latDestino, lonDestino) {
    var suscriptor = this.leerDatosSuscriptor().suscriptor;
    var dist = this.calcularDistancia(suscriptor.sus_lat, suscriptor.sus_lng, latDestino, lonDestino);
    return dist;
  }

  calcularDistancia(lat1, lon1, lat2, lon2) {
    function gradosARadianes(grados) {
      return grados * Math.PI / 180;
    }

    var radioTierra = 6371e3; // radios en metros
    var deltaLat = gradosARadianes(lat2 - lat1);
    var deltaLon = gradosARadianes(lon2 - lon1);

    var a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(gradosARadianes(lat1)) * Math.cos(gradosARadianes(lat2)) *
      Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return radioTierra * c; // Distancia en metros
  }

  calcularTarifa(distancia) {
    var cnfsus = this.leerDatosSuscriptor().configuracion;
    var tarifas = cnfsus.tarifasDistancias;
    for (let i = 0; i < tarifas.length; i++) {
      if (distancia <= tarifas[i].maximaDistancia) {
        return tarifas[i].tarifa;
      }
    }
    // Retorna null o una tarifa por defecto si no se encuentra una tarifa adecuada
    return null;
  }

}
export default new FuncionesVarias();